import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import chatList, { getChatListSaga } from 'modules/actions/chat';
import fontSize from 'modules/actions/fontSize';
import setCategory from 'modules/actions/selectCategory';
import { sendSatisfyactionSaga } from 'modules/actions/starScore';
import organizationResult, { sendOrganizationSaga } from 'modules/actions/sendOrganization';
import autoComplete, { autoCompleteSaga } from 'modules/actions/autoComplete/index';
import isActive from 'modules/actions/statusMenu/index';
import quality, { getQualityOptions, sendQualityGenerator, checkQualityGenerator } from 'modules/actions/quality';
import guideMapGetList , { guideMapSaga, setLevel1Saga } from 'modules/actions/guideMap';
import forbiddenAutoList ,{ forbiddenAutoSaga } from 'modules/actions/forbiddenAuto';
import termSearchList , { termSearchSaga, termPageSaga } from 'modules/actions/termSearch';

const rootReducer = combineReducers({
  autoComplete,
  isActive,
  chatList,
  fontSize,
  quality,
  organizationResult,
  guideMapGetList,
  setCategory,
  forbiddenAutoList,
  termSearchList,
});

export function* rootSaga() {
  yield all([termPageSaga(), termSearchSaga(),forbiddenAutoSaga(), setLevel1Saga(), guideMapSaga(),autoCompleteSaga(), getChatListSaga(), sendSatisfyactionSaga(),sendOrganizationSaga(),  getQualityOptions(), sendQualityGenerator(), sendOrganizationSaga(), checkQualityGenerator()]);
}

export default rootReducer;

